import React, { Component } from "react";
import PropTypes from "prop-types";

class Alert extends Component {
  static propTypes = {
    children: PropTypes.any,
    intent: PropTypes.oneOf(["warning", "alert", "success", "info"]),
  };

  render() {
    const { intent = "default" } = this.props;
    const intentStyles = { ...styles.base, ...styles[intent] };
    return <div style={intentStyles}>{this.props.children}</div>;
  }
}

const styles = {
  base: {
    border: "1px solid gray",
    borderLeft: "5px solid gray",
    borderRadius: 5,
    fontSize: 16,
    padding: 15,
    margin: "15px 0",
  },
  default: {},
  alert: {
    borderColor: "red",
  },
  success: {
    borderColor: "#01a33e",
  },
  warning: {
    borderColor: "#ffa500",
  },
  info: {
    borderColor: "#026fb8",
  },
};

export default Alert;
